import {Button, Image, Space} from 'antd'
import PhotoSvg from 'components/Svgs/PhotoSvg'
import {Photo} from 'conts/imageBase64'
import React, {useContext} from 'react'
import useToggle from 'react-use/lib/useToggle'
import ImagesLightBox from '../ImagesLightBox/ImagesLightBox'
import {LayoutContext} from '../layouts/Default/LayoutContext'
import {ImageEmbed} from './ImageEmbed'
import Translate from "../../modules/local/Translate";
import {PiCaretLeftBold, PiCaretRightBold} from "react-icons/pi";
import {renderIf} from "../../views/Shared";
import {HiViewfinderCircle} from "react-icons/hi2";
import {ImagePlaceholder} from "../Svgs/PhotoSvg";

export function GalleryEmbed({images}) {
    const [open, toggle] = useToggle()
    const {isSm} = useContext(LayoutContext)

    const preview = {
        mask: (
            <div className="w-full h-full relative">
                <HiViewfinderCircle
                    size={16}
                    style={{top: 10, right: 10}}
                    className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                />
            </div>
        ),
    }

    const GridImage = ({images}) => {
        if (images.length === 1) {
            return <ImageEmbed image={images[0]}/>
        } else if (images.length === 2) {
            return (
                <div style={{height: isSm ? '33em' : '33em'}} className="grid grid-cols-2 gap-1">
                    {images.map((e, i) => (
                        <Image
                            key={i}
                            preview={preview}
                            wrapperClassName="w-full"
                            style={{maxHeight: isSm ? '33em' : '33em'}}
                            fallback={Photo}
                            placeholder={
                                <ImagePlaceholder/>
                            }
                            className="w-full h-full object-cover cursor-pointer"
                            src={e}
                        />
                    ))}
                </div>
            )
        } else if (images.length === 3) {
            return (
                <div className="grid grid-cols-2 gap-1">
                    <Image
                        preview={preview}
                        wrapperClassName="w-full"
                        style={{maxHeight: isSm ? '33em' : '33em'}}
                        fallback={Photo}
                        placeholder={<PhotoSvg/>}
                        className="w-full h-full object-cover cursor-pointer"
                        src={images[0]}
                    />
                    <div style={{height: isSm ? '33em' : '33em'}} className="flex flex-col gap-1">
                        <Image
                            preview={preview}
                            wrapperClassName="w-full"
                            wrapperStyle={{
                                maxHeight: 'calc(50% - 0.125rem)'
                            }}
                            fallback={Photo}
                            placeholder={<PhotoSvg/>}
                            className="w-full h-full object-cover cursor-pointer"
                            src={images[1]}
                        />
                        <Image
                            preview={preview}
                            wrapperClassName="w-full"
                            wrapperStyle={{
                                maxHeight: 'calc(50% - 0.125rem)'
                            }}
                            fallback={Photo}
                            placeholder={<PhotoSvg/>}
                            className="w-full h-full object-cover cursor-pointer"
                            src={images[2]}
                        />
                    </div>
                </div>
            )
        } else if (images.length >= 4) {
            return (
                <div className="grid grid-cols-2 gap-1">
                    <Image
                        preview={preview}
                        wrapperClassName="w-full"
                        style={{
                            maxHeight: isSm ? '33em' : '33em',
                        }}
                        fallback={Photo}
                        placeholder={<PhotoSvg/>}
                        className="w-full h-full object-cover cursor-pointer"
                        src={images[0]}
                    />
                    <div style={{height: isSm ? '33em' : '33em'}} className="flex flex-col gap-1">
                        <Image
                            preview={preview}
                            wrapperClassName="w-full"
                            wrapperStyle={{
                                maxHeight: '50%'
                            }}
                            fallback={Photo}
                            placeholder={<PhotoSvg/>}
                            className="w-full h-full object-cover cursor-pointer"
                            src={images[1]}
                        />
                        <div className="h-full grid grid-cols-2 gap-1">
                            <Image
                                preview={preview}
                                wrapperClassName="w-full"
                                fallback={Photo}
                                placeholder={<PhotoSvg/>}
                                className="w-full h-full object-cover cursor-pointer"
                                src={images[2]}
                            />
                            <Image
                                preview={preview}
                                wrapperClassName="w-full"
                                fallback={Photo}
                                placeholder={<PhotoSvg/>}
                                className="w-full h-full object-cover cursor-pointer"
                                src={images[3]}
                            />
                        </div>
                    </div>
                </div>
            )
        }
        return null
    }

    return (
        <Translate>
            {(t) => renderIf(
                images,
                <React.Fragment>
                    <div onClick={toggle} className="w-full background-200 overflow-hidden relative">
                        <GridImage images={images}/>
                        {renderIf(
                            images.length >= 2,
                            <Space.Compact style={{rowGap: 0}} size="small"
                                           className="button-gallery-images absolute bottom-0 right-0 p-2 z-10">
                                <Button
                                    type="primary"
                                    style={{
                                        border: 'none',
                                        background: 'rgba(0, 0, 0, 0.53)',
                                        borderTopLeftRadius: '0.3rem',
                                        borderBottomLeftRadius: '0.3rem',
                                    }}
                                    icon={<PiCaretLeftBold size={12}/>}
                                    className="flex flex-center no-shadow"
                                />
                                <Button
                                    type="primary"
                                    style={{border: 'none', background: 'rgba(0, 0, 0, 0.53)',}}
                                    className="font-normal flex flex-center no-shadow">
                                    <span style={{fontSize: '0.6rem'}} className="italic lowercase leading-snug">
                                        {`1 - ${images.length} ${t('image')}`}
                                    </span>
                                </Button>
                                <Button
                                    type="primary"
                                    style={{
                                        border: 'none',
                                        background: 'rgba(0, 0, 0, 0.53)',
                                        borderTopRightRadius: '0.3rem',
                                        borderBottomRightRadius: '0.3rem',
                                    }}
                                    icon={<PiCaretRightBold size={12}/>}
                                    className="flex flex-center no-shadow"
                                />
                            </Space.Compact>
                        )}
                    </div>
                    {open && (
                        <ImagesLightBox
                            images={images}
                            onCloseRequest={toggle}
                        />
                    )}
                </React.Fragment>
            )}
        </Translate>
    )
}
